import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { ToastContainer } from 'react-toastify'
import { INTERVALO_CORTO } from '../../../../config/settings'
import TablaPlanDeEmbarqueBodegasView from '../../components/planDeEmbarque/TablaPlanDeEmbarqueBodegasView'
import { obtenerDatosPlanDeEmbarqueBodegas, obtenerBodegasBuque } from '../../actions/PlanDeEmbarqueActions'
import { reduxForm } from 'redux-form'
import { FORM_PLAN_DE_EMBARQUE } from '../../../../config/forms'
import { EMPLY_PLAN_DE_EMBARQUE_BODEGA } from '../../actions/constantesPlanDeEmbarque'

const TablaPlanDeEmbarqueBodegas = (props) => {
  const { fecha, buque, requestingBodegas, requestingPlanDeEmbarque } = props

  useEffect(() => {
    async function getData () {
      const { change: formChange } = props
      props.obtenerDatosPlanDeEmbarqueBodegas(fecha)
      formChange('buque', buque)
      formChange('fechaDeReferencia', fecha)
    }
    if (!requestingPlanDeEmbarque) { getData() }
    if (!requestingBodegas) { props.obtenerBodegasBuque(buque) }
  }, [props, buque, fecha, requestingBodegas, requestingPlanDeEmbarque])

  return (
    <div style={{ width: '98%', margin: '22px auto' }}>
      <ToastContainer autoClose={INTERVALO_CORTO} />
      <TablaPlanDeEmbarqueBodegasView />
    </div>
  )
}

const mapStateToProps = (state) => ({
  requestingBodegas: state.buque.requestingBodegas,
  requestingPlanDeEmbarque: state.buque.requestingPlanDeEmbarque
})

const mapActionsToProps = {
  obtenerDatosPlanDeEmbarqueBodegas,
  obtenerBodegasBuque
}

const withRedux = connect(mapStateToProps, mapActionsToProps)

const withReduxForm = reduxForm({
  form: FORM_PLAN_DE_EMBARQUE,
  initialValues: EMPLY_PLAN_DE_EMBARQUE_BODEGA,
  enableReinitialize: true
})

export default withRedux(withReduxForm(TablaPlanDeEmbarqueBodegas))
